import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AuthBase } from '../../base/services/auth-base';
import { TotaraAuthApiService } from './totara-auth-api.service';

@Injectable({
  providedIn: 'root'
})
export class TotaraAuthService extends AuthBase {
  protected apiUrl = environment.totaraApi;
  protected authRedirectUrl = 'auth-totara';
  protected tokenName = 'mdtTotaraToken';

  constructor(authApiService: TotaraAuthApiService, router: Router) {
    super(authApiService, router);
  }
}
